import { Scene, MeshStandardMaterial, Vector3, Mesh, Texture, Vector2 } from "three";
import PropsManager from "../utils/props_manager"; // Update this path as needed
import AssetManager from "../utils/asset_manager";

class PoolProps {
  private scene: Scene;
  private propsManager: PropsManager;

  constructor(scene: Scene) {
    this.scene = scene;
    this.propsManager = new PropsManager(this.scene);
    this.addProps();
  }

  private addProps(): void {


    const worldScale = 0.007;

    const parasol = {
      position: new Vector3(5.5, 0.0, -4),
      rotation: new Vector3(0, Math.PI / 2.4, 0),
      scale: new Vector3(worldScale*1.4,worldScale*1.4,worldScale*1.4),
      mesh: AssetManager.getInstance().getAsset("parasol") as Mesh,
      
    };

    this.propsManager.addProp(parasol,1);

    const beachSeat = {
      position: new Vector3(4.5, 0.0, 4),
      rotation: new Vector3(0, Math.PI / 1.34, 0),
      scale: new Vector3(worldScale,worldScale,worldScale),
      mesh: AssetManager.getInstance().getAsset("relax") as Mesh,
      
    };

    this.propsManager.addProp(beachSeat,2);

    const beachSeat2 = {
      position: new Vector3(3.3, 0.0, 4),
      rotation: new Vector3(0, Math.PI / 2.8, 0),
      scale: new Vector3(worldScale,worldScale,worldScale),
      mesh: AssetManager.getInstance().getAsset("relax") as Mesh,
      
    };

    this.propsManager.addProp(beachSeat2,2);

    
    const relax2 = {
      position: new Vector3(4, 0.0, -4.1),
      rotation: new Vector3(0, -Math.PI / 3.6, 0),
      scale: new Vector3(worldScale,worldScale,worldScale),
      mesh: AssetManager.getInstance().getAsset("relax2") as Mesh,
      
    };

    this.propsManager.addProp(relax2, 1);

    const relax3 = {
      position: new Vector3(2.5, 0.0, -4.2),
      rotation: new Vector3(0, -Math.PI / 3.6, 0),
      scale: new Vector3(worldScale,worldScale,worldScale),
      mesh: AssetManager.getInstance().getAsset("relax2") as Mesh,
      
    };

    this.propsManager.addProp(relax3,1);

    console.log(AssetManager.getInstance().getAsset("pot1"));
    const pot1 = {
      position: new Vector3(7, -1.37, 2.8),
      rotation: new Vector3(0, Math.PI / 1.6, 0),
      scale: new Vector3(worldScale*2,worldScale*2,worldScale*2),
      mesh: AssetManager.getInstance().getAsset("pot1") as Mesh,
      
    };

    this.propsManager.addProp(pot1,2);

    const pot2 = {
      position: new Vector3(8.4, -1.37, -5.1),
      rotation: new Vector3(0, Math.PI / 2.6, 0),
      scale: new Vector3(worldScale*2,worldScale*2,worldScale*2),
      mesh: AssetManager.getInstance().getAsset("pot1") as Mesh,
      
    };

    this.propsManager.addProp(pot2,2);
  }
}

export default PoolProps;
